"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfiniteRound__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        type: "constructor",
        inputs: [
            {
                name: "_classHash",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_propHouse",
                type: "address",
                internalType: "address",
            },
            {
                name: "_starknet",
                type: "address",
                internalType: "address",
            },
            {
                name: "_messenger",
                type: "address",
                internalType: "address",
            },
            {
                name: "_roundFactory",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_executionRelayer",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "_manager",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "ASSET_RECLAIM_DELAY",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "MAX_WINNER_TREE_DEPTH",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "MIN_VOTE_PERIOD_DURATION",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "balanceOf",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "balanceOfBatch",
        inputs: [
            {
                name: "owners",
                type: "address[]",
                internalType: "address[]",
            },
            {
                name: "ids",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        outputs: [
            {
                name: "balances",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "cancel",
        inputs: [],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "claim",
        inputs: [
            {
                name: "proposalId",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "proof",
                type: "tuple",
                internalType: "struct IncrementalTreeProof",
                components: [
                    {
                        name: "siblings",
                        type: "bytes32[]",
                        internalType: "bytes32[]",
                    },
                    {
                        name: "pathIndices",
                        type: "uint8[]",
                        internalType: "uint8[]",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "claimTo",
        inputs: [
            {
                name: "recipient",
                type: "address",
                internalType: "address",
            },
            {
                name: "proposalId",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "proof",
                type: "tuple",
                internalType: "struct IncrementalTreeProof",
                components: [
                    {
                        name: "siblings",
                        type: "bytes32[]",
                        internalType: "bytes32[]",
                    },
                    {
                        name: "pathIndices",
                        type: "uint8[]",
                        internalType: "uint8[]",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "claimedWinnerCount",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint32",
                internalType: "uint32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "classHash",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "completeFinalization",
        inputs: [
            {
                name: "winnerCount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "currentWinnerCount",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint32",
                internalType: "uint32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "emergencyCancel",
        inputs: [],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "executionRelayer",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "finalizationStartedAt",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "finalizedAt",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "getRegistrationPayload",
        inputs: [
            {
                name: "config",
                type: "tuple",
                internalType: "struct IInfiniteRound.RoundConfig",
                components: [
                    {
                        name: "metaTx",
                        type: "tuple",
                        internalType: "struct MetaTransaction",
                        components: [
                            {
                                name: "relayer",
                                type: "address",
                                internalType: "address",
                            },
                            {
                                name: "deposit",
                                type: "uint256",
                                internalType: "uint256",
                            },
                        ],
                    },
                    {
                        name: "proposalThreshold",
                        type: "uint248",
                        internalType: "uint248",
                    },
                    {
                        name: "proposingStrategies",
                        type: "uint256[]",
                        internalType: "uint256[]",
                    },
                    {
                        name: "proposingStrategyParamsFlat",
                        type: "uint256[]",
                        internalType: "uint256[]",
                    },
                    {
                        name: "votingStrategies",
                        type: "uint256[]",
                        internalType: "uint256[]",
                    },
                    {
                        name: "votingStrategyParamsFlat",
                        type: "uint256[]",
                        internalType: "uint256[]",
                    },
                    {
                        name: "startTimestamp",
                        type: "uint40",
                        internalType: "uint40",
                    },
                    {
                        name: "votePeriodDuration",
                        type: "uint40",
                        internalType: "uint40",
                    },
                    {
                        name: "quorumFor",
                        type: "uint248",
                        internalType: "uint248",
                    },
                    {
                        name: "quorumAgainst",
                        type: "uint248",
                        internalType: "uint248",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "payload",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "house",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        stateMutability: "pure",
    },
    {
        type: "function",
        name: "id",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "initialize",
        inputs: [
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "isApprovedForAll",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "address",
                internalType: "address",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isAssetWinner",
        inputs: [
            {
                name: "user",
                type: "address",
                internalType: "address",
            },
            {
                name: "proposalId",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "proof",
                type: "tuple",
                internalType: "struct IncrementalTreeProof",
                components: [
                    {
                        name: "siblings",
                        type: "bytes32[]",
                        internalType: "bytes32[]",
                    },
                    {
                        name: "pathIndices",
                        type: "uint8[]",
                        internalType: "uint8[]",
                    },
                ],
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "isClaimed",
        inputs: [
            {
                name: "proposalId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "claimed",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "kind",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "manager",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IManager",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "messenger",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IMessenger",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "onDepositReceived",
        inputs: [
            {
                name: "depositor",
                type: "address",
                internalType: "address",
            },
            {
                name: "id",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "onDepositsReceived",
        inputs: [
            {
                name: "depositor",
                type: "address",
                internalType: "address",
            },
            {
                name: "ids",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "amounts",
                type: "uint256[]",
                internalType: "uint256[]",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "onERC1155BatchReceived",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "onERC1155Received",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "onERC721Received",
        inputs: [
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "address",
                internalType: "address",
            },
            {
                name: "",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "propHouse",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IPropHouse",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "reclaim",
        inputs: [
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "reclaimTo",
        inputs: [
            {
                name: "recipient",
                type: "address",
                internalType: "address",
            },
            {
                name: "assets",
                type: "tuple[]",
                internalType: "struct Asset[]",
                components: [
                    {
                        name: "assetType",
                        type: "uint8",
                        internalType: "enum AssetType",
                    },
                    {
                        name: "token",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "identifier",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "safeBatchTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "ids",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "amounts",
                type: "uint256[]",
                internalType: "uint256[]",
            },
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "safeTransferFrom",
        inputs: [
            {
                name: "from",
                type: "address",
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                internalType: "address",
            },
            {
                name: "id",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "data",
                type: "bytes",
                internalType: "bytes",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "setApprovalForAll",
        inputs: [
            {
                name: "operator",
                type: "address",
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                internalType: "bool",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "starknet",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "address",
                internalType: "contract IStarknetCore",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "startFinalization",
        inputs: [],
        outputs: [],
        stateMutability: "payable",
    },
    {
        type: "function",
        name: "startTimestamp",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "state",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint8",
                internalType: "enum IInfiniteRound.RoundState",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "supportsInterface",
        inputs: [
            {
                name: "interfaceId",
                type: "bytes4",
                internalType: "bytes4",
            },
        ],
        outputs: [
            {
                name: "",
                type: "bool",
                internalType: "bool",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "title",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "pure",
    },
    {
        type: "function",
        name: "updateWinners",
        inputs: [
            {
                name: "newWinnerCount",
                type: "uint32",
                internalType: "uint32",
            },
            {
                name: "merkleRootLow",
                type: "uint256",
                internalType: "uint256",
            },
            {
                name: "merkleRootHigh",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [],
        stateMutability: "nonpayable",
    },
    {
        type: "function",
        name: "uri",
        inputs: [
            {
                name: "tokenId",
                type: "uint256",
                internalType: "uint256",
            },
        ],
        outputs: [
            {
                name: "",
                type: "string",
                internalType: "string",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "votePeriodDuration",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "uint40",
                internalType: "uint40",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "function",
        name: "winnerMerkleRoot",
        inputs: [],
        outputs: [
            {
                name: "",
                type: "bytes32",
                internalType: "bytes32",
            },
        ],
        stateMutability: "view",
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                name: "account",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "operator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "approved",
                type: "bool",
                indexed: false,
                internalType: "bool",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "AssetClaimed",
        inputs: [
            {
                name: "proposalId",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "claimer",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "recipient",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "asset",
                type: "tuple",
                indexed: false,
                internalType: "struct PackedAsset",
                components: [
                    {
                        name: "assetId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "AssetsClaimed",
        inputs: [
            {
                name: "proposalId",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "claimer",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "recipient",
                type: "address",
                indexed: false,
                internalType: "address",
            },
            {
                name: "assets",
                type: "tuple[]",
                indexed: false,
                internalType: "struct PackedAsset[]",
                components: [
                    {
                        name: "assetId",
                        type: "uint256",
                        internalType: "uint256",
                    },
                    {
                        name: "amount",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundCancelled",
        inputs: [],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundEmergencyCancelled",
        inputs: [],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundFinalizationStarted",
        inputs: [],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundFinalized",
        inputs: [],
        anonymous: false,
    },
    {
        type: "event",
        name: "RoundRegistered",
        inputs: [
            {
                name: "metaTx",
                type: "tuple",
                indexed: false,
                internalType: "struct MetaTransaction",
                components: [
                    {
                        name: "relayer",
                        type: "address",
                        internalType: "address",
                    },
                    {
                        name: "deposit",
                        type: "uint256",
                        internalType: "uint256",
                    },
                ],
            },
            {
                name: "proposalThreshold",
                type: "uint248",
                indexed: false,
                internalType: "uint248",
            },
            {
                name: "proposingStrategies",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
            {
                name: "proposingStrategyParamsFlat",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
            {
                name: "votingStrategies",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
            {
                name: "votingStrategyParamsFlat",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
            {
                name: "startTimestamp",
                type: "uint40",
                indexed: false,
                internalType: "uint40",
            },
            {
                name: "votePeriodDuration",
                type: "uint40",
                indexed: false,
                internalType: "uint40",
            },
            {
                name: "quorumFor",
                type: "uint248",
                indexed: false,
                internalType: "uint248",
            },
            {
                name: "quorumAgainst",
                type: "uint248",
                indexed: false,
                internalType: "uint248",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "TransferBatch",
        inputs: [
            {
                name: "operator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "from",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "ids",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
            {
                name: "values",
                type: "uint256[]",
                indexed: false,
                internalType: "uint256[]",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "TransferSingle",
        inputs: [
            {
                name: "operator",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "from",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "to",
                type: "address",
                indexed: true,
                internalType: "address",
            },
            {
                name: "id",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
            {
                name: "value",
                type: "uint256",
                indexed: false,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "URI",
        inputs: [
            {
                name: "value",
                type: "string",
                indexed: false,
                internalType: "string",
            },
            {
                name: "id",
                type: "uint256",
                indexed: true,
                internalType: "uint256",
            },
        ],
        anonymous: false,
    },
    {
        type: "event",
        name: "WinnersUpdated",
        inputs: [
            {
                name: "winnerCount",
                type: "uint64",
                indexed: false,
                internalType: "uint64",
            },
        ],
        anonymous: false,
    },
    {
        type: "error",
        name: "ALREADY_CLAIMED",
        inputs: [],
    },
    {
        type: "error",
        name: "CANCELLATION_NOT_AVAILABLE",
        inputs: [],
    },
    {
        type: "error",
        name: "ETHER_TRANSFER_FAILED",
        inputs: [],
    },
    {
        type: "error",
        name: "FINALIZATION_NOT_AVAILABLE",
        inputs: [],
    },
    {
        type: "error",
        name: "INSUFFICIENT_ETHER_SUPPLIED",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ASSET_TYPE",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_ERC721_TRANSFER_AMOUNT",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_MERKLE_PROOF",
        inputs: [],
    },
    {
        type: "error",
        name: "INVALID_STRATEGY",
        inputs: [
            {
                name: "strategy",
                type: "uint256",
                internalType: "uint256",
            },
        ],
    },
    {
        type: "error",
        name: "LENGTH_MISMATCH",
        inputs: [],
    },
    {
        type: "error",
        name: "MISSING_ASSET_AMOUNT",
        inputs: [],
    },
    {
        type: "error",
        name: "MUST_PROCESS_REMAINING_WINNERS",
        inputs: [],
    },
    {
        type: "error",
        name: "NOT_AUTHORIZED",
        inputs: [],
    },
    {
        type: "error",
        name: "NO_AGAINST_QUORUM_PROVIDED",
        inputs: [],
    },
    {
        type: "error",
        name: "NO_FOR_QUORUM_PROVIDED",
        inputs: [],
    },
    {
        type: "error",
        name: "NO_META_TX_RELAYER_PROVIDED",
        inputs: [],
    },
    {
        type: "error",
        name: "NO_PROPOSING_STRATEGIES_PROVIDED",
        inputs: [],
    },
    {
        type: "error",
        name: "NO_VOTING_STRATEGIES_PROVIDED",
        inputs: [],
    },
    {
        type: "error",
        name: "ONLY_PROP_HOUSE",
        inputs: [],
    },
    {
        type: "error",
        name: "ONLY_ROUND_MANAGER",
        inputs: [],
    },
    {
        type: "error",
        name: "ONLY_SECURITY_COUNCIL",
        inputs: [],
    },
    {
        type: "error",
        name: "RECLAMATION_NOT_AVAILABLE",
        inputs: [],
    },
    {
        type: "error",
        name: "UNSAFE_RECIPIENT",
        inputs: [],
    },
    {
        type: "error",
        name: "UNUSED_ASSET_PARAMETERS",
        inputs: [],
    },
    {
        type: "error",
        name: "VOTE_PERIOD_DURATION_TOO_SHORT",
        inputs: [],
    },
    {
        type: "error",
        name: "WINNERS_ALREADY_PROCESSED",
        inputs: [],
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class InfiniteRound__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_classHash, _propHouse, _starknet, _messenger, _roundFactory, _executionRelayer, _manager, overrides) {
        return super.deploy(_classHash, _propHouse, _starknet, _messenger, _roundFactory, _executionRelayer, _manager, overrides || {});
    }
    getDeployTransaction(_classHash, _propHouse, _starknet, _messenger, _roundFactory, _executionRelayer, _manager, overrides) {
        return super.getDeployTransaction(_classHash, _propHouse, _starknet, _messenger, _roundFactory, _executionRelayer, _manager, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.InfiniteRound__factory = InfiniteRound__factory;
InfiniteRound__factory.bytecode = _bytecode;
InfiniteRound__factory.abi = _abi;
